import React, { useState, useEffect } from 'react';
import UserAPI from './UserAPI';
import { formatTitleToDB, formatTitleToDisplay } from '../utils/Functions';
import { Container, Row, Col, Form, Button, Table } from 'react-bootstrap';

const SongsMenu = () => {
    const [songs, setSongs] = useState([]);

    const loadSongs = async() => {
        const requestBody = JSON.stringify({
            'request_type': 'user',
            'idToken': localStorage.getItem('idToken'),
            'user_request_type': 'songs',
            'action': 'scan'
        });
        
        const jsonData = await UserAPI(requestBody);
        const result = JSON.parse(jsonData.body);
        setSongs([]);
        result.forEach(element => {
            var title = element[0];
            title = formatTitleToDisplay(title);
            var artist = element[1];
            artist = formatTitleToDisplay(artist);
            setSongs(prevSongs => [...prevSongs, {title: title, artist: artist}]);
        });
    }

    const handleAddSong = async () => {
        const artist = document.getElementById('artistInput').value;
        const title = document.getElementById('titleInput').value;
        
        if (artist.length + title.length > 50) {
            alert('Combined length of artist and title must not exceed 50 characters');
            return;
        }

        const idToken = localStorage.getItem('idToken');
        const requestBody = JSON.stringify({
            'request_type': 'user',
            'idToken': idToken,
            'user_request_type': 'songs',
            'action': 'add',
            'artist': formatTitleToDB(artist),
            'title': formatTitleToDB(title)
        });
        
        await UserAPI(requestBody);
        loadSongs();
    }

    const handleRemoveSong = async (index) => {
        const idToken = localStorage.getItem('idToken');
        const artist = songs[index].artist;
        const title = songs[index].title;
        const requestBody = JSON.stringify({
            'request_type': 'user',
            'idToken': idToken,
            'user_request_type': 'songs',
            'action': 'delete',
            'artist': formatTitleToDB(artist),
            'title': formatTitleToDB(title)
        });
        await UserAPI(requestBody);
        loadSongs();
    }

    const handlePlaySong = async (index) => {
        const idToken = localStorage.getItem('idToken');
        const artist = songs[index].artist;
        const title = songs[index].title;
        const requestBody = JSON.stringify({
            'request_type': 'user',
            'idToken': idToken,
            'user_request_type': 'event',
            'event_type': 'playsong',
            'artistname': formatTitleToDB(artist),
            'songname': formatTitleToDB(title)
        });
        await UserAPI(requestBody);
    }
    
    useEffect(() => {
        loadSongs();
    }, []);

    return (
        <Container fluid>
            <Row className="mb-4">
                <Col>
                    <Form className="d-flex gap-2">
                        <Form.Control
                            id="titleInput"
                            placeholder="Title"
                            className="flex-grow-1"
                        />
                        <Form.Control
                            id="artistInput"
                            placeholder="Artist"
                            className="flex-grow-1"
                        />
                        <Button 
                            variant="outline-light"
                            onClick={handleAddSong}
                        >
                            Add
                        </Button>
                    </Form>
                </Col>
            </Row>

            <Row>
                <Col>
                    <div className="table-responsive">
                        <Table variant="dark" hover>
                            <thead>
                                <tr>
                                    <th style={{ width: '40%', whiteSpace: 'nowrap' }}>Title</th>
                                    <th style={{ width: '40%', whiteSpace: 'nowrap' }}>Artist</th>
                                    <th style={{ width: '20%' }} className="text-end"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {songs.map((song, index) => (
                                    <tr key={index}>
                                        <td className="text-truncate" style={{ maxWidth: '200px' }}>{song.title}</td>
                                        <td className="text-truncate" style={{ maxWidth: '200px' }}>{song.artist}</td>
                                        <td className="text-end" style={{ whiteSpace: 'nowrap' }}>
                                            <Button 
                                                variant="outline-light"
                                                size="sm"
                                                onClick={() => handleRemoveSong(index)}
                                                className="me-2"
                                            >
                                                ✕
                                            </Button>
                                            <Button 
                                                variant="outline-light"
                                                size="sm"
                                                onClick={() => handlePlaySong(index)}
                                            >
                                                ▶
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default SongsMenu;